// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2dItZ","info":"Note_info__3Y8DQ","note":"Note_note__U3dS4","actions":"Note_actions__3eQxX"};